module.exports = __webpack_public_path__ + "static/media/dollar-icon-full.ec9da965.svg";